import {
  FaUsers,
  FaHeartbeat,
  FaFolderOpen,
  FaRobot,
  FaChartLine,
  FaSearch,
  FaSmile,
  FaCheckCircle,
  FaMapMarkedAlt
} from "react-icons/fa";
import AdminSidebarShell from "../components/AdminSidebarShell";

const summaryCards = [
  {
    title: "Active Members",
    value: "--",
    description: "Last 7 days",
    icon: FaUsers
  },
  {
    title: "Engagement Score",
    value: "--",
    description: "Overall elder engagement",
    icon: FaHeartbeat
  },
  {
    title: "Vault Usage",
    value: "--",
    description: "Document activity",
    icon: FaFolderOpen
  },
  {
    title: "AI Usage",
    value: "--",
    description: "Agent interactions",
    icon: FaRobot
  }
];

const AdminAnalyticsPage = () => {
  return (
    <AdminSidebarShell activeItem="analytics">
      <div style={page}>
        <div style={header}>
          <h1 style={title}>Analytics</h1>
          <p style={subtitle}>
            Family Circle insights will appear here as your workspace activity grows.
          </p>
        </div>

        <section style={summaryGrid}>
          {summaryCards.map((item) => {
            const Icon = item.icon;
            return (
              <article key={item.title} style={summaryCard}>
                <div style={summaryIconWrap}>
                  <Icon />
                </div>
                <p style={summaryTitle}>{item.title}</p>
                <p style={summaryValue}>{item.value}</p>
                <p style={summaryDescription}>{item.description}</p>
              </article>
            );
          })}
        </section>

        <section style={analyticsGrid}>
          <article style={{ ...panelCard, ...wideCard }}>
            <div style={panelHeader}>
              <div style={panelIconWrap}>
                <FaChartLine />
              </div>
              <div>
                <h2 style={panelTitle}>Family Activity Overview</h2>
                <p style={panelSubtitle}>Activity chart coming soon</p>
              </div>
            </div>
            <div style={chartPlaceholder} />
          </article>

          <article style={panelCard}>
            <div style={panelHeader}>
              <div style={panelIconWrap}>
                <FaSearch />
              </div>
              <div>
                <h2 style={panelTitle}>Vault Insights</h2>
                <p style={panelSubtitle}>Most accessed documents and common search topics</p>
              </div>
            </div>
            <div style={listSection}>
              <p style={listHeading}>Most Accessed Documents</p>
              <ul style={list}>
                <li style={listItem}>Care plan summary</li>
                <li style={listItem}>Medication guidance notes</li>
                <li style={listItem}>Family support checklist</li>
              </ul>
            </div>
            <div style={listSection}>
              <p style={listHeading}>Common Search Topics</p>
              <ul style={list}>
                <li style={listItem}>Daily routines</li>
                <li style={listItem}>Well-being reminders</li>
                <li style={listItem}>Emergency support contacts</li>
              </ul>
            </div>
          </article>

          <article style={panelCard}>
            <div style={panelHeader}>
              <div style={panelIconWrap}>
                <FaSmile />
              </div>
              <div>
                <h2 style={panelTitle}>Elder Well-Being Signals</h2>
                <p style={panelSubtitle}>Well-being analytics coming soon</p>
              </div>
            </div>
            <div style={signalPlaceholder}>
              <div style={signalLineShort} />
              <div style={signalLineMedium} />
              <div style={signalLineLong} />
            </div>
          </article>

          <article style={panelCard}>
            <div style={panelHeader}>
              <div style={panelIconWrap}>
                <FaCheckCircle />
              </div>
              <div>
                <h2 style={panelTitle}>Agent Performance</h2>
                <p style={panelSubtitle}>Static preview of future assistant metrics</p>
              </div>
            </div>
            <div style={statsStack}>
              <div style={statRow}>
                <span style={statLabel}>Questions answered</span>
                <strong style={statValue}>--</strong>
              </div>
              <div style={statRow}>
                <span style={statLabel}>Success rate</span>
                <strong style={statValue}>--</strong>
              </div>
            </div>
          </article>

          <article style={{ ...panelCard, ...wideCard }}>
            <div style={panelHeader}>
              <div style={panelIconWrap}>
                <FaMapMarkedAlt />
              </div>
              <div>
                <h2 style={panelTitle}>Service Usage</h2>
                <p style={panelSubtitle}>Service analytics coming soon</p>
              </div>
            </div>
            <div style={servicePlaceholder} />
          </article>
        </section>
      </div>
    </AdminSidebarShell>
  );
};

export default AdminAnalyticsPage;

const page = {
  maxWidth: "1160px",
  margin: "0 auto",
  display: "grid",
  gap: "24px",
  fontFamily: "system-ui, -apple-system, sans-serif"
};

const header = {
  display: "grid",
  gap: "8px"
};

const title = {
  margin: 0,
  color: "#1e293b",
  fontSize: "32px",
  fontWeight: "700"
};

const subtitle = {
  margin: 0,
  color: "#64748b",
  fontSize: "15px"
};

const summaryGrid = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
  gap: "18px"
};

const summaryCard = {
  background: "#ffffff",
  borderRadius: "16px",
  border: "1px solid #e2e8f0",
  boxShadow: "0 10px 28px rgba(14,85,128,0.08)",
  padding: "22px",
  display: "grid",
  gap: "10px"
};

const summaryIconWrap = {
  width: "48px",
  height: "48px",
  borderRadius: "14px",
  background: "#e8f3fb",
  color: "#0E5580",
  display: "grid",
  placeItems: "center",
  fontSize: "20px"
};

const summaryTitle = {
  margin: 0,
  color: "#334155",
  fontSize: "15px",
  fontWeight: "600"
};

const summaryValue = {
  margin: 0,
  color: "#0E5580",
  fontSize: "34px",
  fontWeight: "800",
  lineHeight: 1
};

const summaryDescription = {
  margin: 0,
  color: "#64748b",
  fontSize: "13px"
};

const analyticsGrid = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
  gap: "20px"
};

const panelCard = {
  background: "#ffffff",
  borderRadius: "16px",
  border: "1px solid #e2e8f0",
  boxShadow: "0 10px 28px rgba(14,85,128,0.08)",
  padding: "24px",
  display: "grid",
  gap: "18px"
};

const wideCard = {
  gridColumn: "span 2"
};

const panelHeader = {
  display: "flex",
  alignItems: "flex-start",
  gap: "14px"
};

const panelIconWrap = {
  width: "46px",
  height: "46px",
  borderRadius: "14px",
  background: "#f0f7fd",
  color: "#0E5580",
  display: "grid",
  placeItems: "center",
  fontSize: "18px",
  flexShrink: 0
};

const panelTitle = {
  margin: 0,
  color: "#1e293b",
  fontSize: "22px",
  fontWeight: "700"
};

const panelSubtitle = {
  margin: "6px 0 0",
  color: "#64748b",
  fontSize: "14px"
};

const chartPlaceholder = {
  minHeight: "220px",
  borderRadius: "16px",
  border: "1px dashed #cbd5e1",
  background:
    "linear-gradient(180deg, rgba(232,243,251,0.8) 0%, rgba(248,251,254,1) 100%)"
};

const listSection = {
  display: "grid",
  gap: "10px"
};

const listHeading = {
  margin: 0,
  color: "#334155",
  fontSize: "14px",
  fontWeight: "700"
};

const list = {
  margin: 0,
  paddingLeft: "18px",
  color: "#475569",
  display: "grid",
  gap: "8px"
};

const listItem = {
  fontSize: "14px"
};

const signalPlaceholder = {
  minHeight: "180px",
  borderRadius: "16px",
  border: "1px dashed #cbd5e1",
  background: "#fbfdff",
  padding: "18px",
  display: "grid",
  alignContent: "center",
  gap: "14px"
};

const signalLineShort = {
  width: "38%",
  height: "12px",
  borderRadius: "999px",
  background: "#cfe3f4"
};

const signalLineMedium = {
  width: "58%",
  height: "12px",
  borderRadius: "999px",
  background: "#bddaf0"
};

const signalLineLong = {
  width: "82%",
  height: "12px",
  borderRadius: "999px",
  background: "#9bc6e6"
};

const statsStack = {
  display: "grid",
  gap: "14px"
};

const statRow = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "16px 18px",
  borderRadius: "14px",
  background: "#f8fbfe",
  border: "1px solid #e2e8f0"
};

const statLabel = {
  color: "#475569",
  fontSize: "15px",
  fontWeight: "600"
};

const statValue = {
  color: "#0E5580",
  fontSize: "24px",
  fontWeight: "800"
};

const servicePlaceholder = {
  minHeight: "220px",
  borderRadius: "16px",
  border: "1px dashed #cbd5e1",
  background:
    "radial-gradient(circle at top left, rgba(78,165,217,0.18), transparent 40%), #fbfdff"
};
